import React from 'react'
import Title from '../components/dashContent/Title'
import { Outlet } from 'react-router-dom';

const Reports = () => {
  return (
    <div className='m-1'>
      <Title text="Relatórios"/>
      <Outlet>
        
      </Outlet>
    </div>
  )
}

export default Reports